import * as React from 'react';
import { IconFee } from 'ui/icons';
import { IconInvoice } from '@tock/icons';
import { consumer } from '@tock/coretypes';
import { useIsSakeIconSetEnabled } from 'omakase/utils/IconMigrationUtil';
import AdditionalCosts from 'components/AdditionalCosts';
import OfferingDetailsMetadataItem from 'components/business/offering/OfferingDetailsMetadataItem';

interface Props {
  price: consumer.OfferedPriceSummary;
  type: consumer.Offering.Type;
}

const OfferingDetailsAdditionalCosts: React.FunctionComponent<Props> = ({ price, type }) => {
  const isSakeIconSetEnabled = useIsSakeIconSetEnabled();
  const renderFees = price.priceDisplayStyle !== 'MIN_REQUIRED_SPEND';

  return renderFees && AdditionalCosts.hasPriceRanges(price) ? (
    <OfferingDetailsMetadataItem
      icon={isSakeIconSetEnabled ? IconInvoice : IconFee}
      data-testid="add-on-details"
    >
      <AdditionalCosts price={price} />
    </OfferingDetailsMetadataItem>
  ) : null;
};

export default OfferingDetailsAdditionalCosts;
